import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom"; // React Router 사용

const CategoryButton = ({ icon, label, color, is_blank, link }) => {
  const navigate = useNavigate(); // 페이지 이동을 위한 함수

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mx: 1 }}>
      <IconButton 
        sx={{
          backgroundColor: color,
          width: 50,
          height: 50,
          borderRadius:2,
          "&:hover": { backgroundColor: color, opacity: 0.8 }
        }}
        onClick={() => is_blank ? window.location.href=link : navigate(link)}
      >{icon}</IconButton>
      <Typography variant="caption" sx={{ mt: 0.5,mb:0.5 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default CategoryButton;
